import { render, staticRenderFns } from "./ModalCreatePO.vue?vue&type=template&id=b20e6a30&"
import script from "./ModalCreatePO.vue?vue&type=script&lang=js&"
export * from "./ModalCreatePO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports